import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useDataProvider, useRecordContext } from 'react-admin';
import { ShsTextInput } from 'src/components/common';
import { CenterFormFields } from 'src/constants/centers';

interface HospitalInfoProps {
    getSource: (source: string) => string;
}

const createLengthValidator = (min: number, max: number, label: string) => {
    return (value: string) => {
        if (!value) return;
        if (value.length < min) return `${label} не може бути менше ${min} символів`;
        if (value.length > max) return `${label} не може перевищувати ${max} символів`;
    };
};

const createCenterNameValidator = (min: number, max: number, dataProvider: any, record: any, label: string) => {
    const baseValidate = createLengthValidator(min, max, label);

    return async (value: string) => {
        const error = baseValidate(value);
        if (error) return error;

        const response = await dataProvider.getList('centers', {
            filter: { keyword: value, 'filters.active': true },
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'name', order: 'ASC' }
        });

        const existing = response.data.find(
            (c: { name: string; shortName: string; id: string }) =>
                (c.name === value || c.shortName === value) && c.id !== record?.id
        );

        if (existing) return 'Вказана назва вже є в системі';
    };
};

export const HospitalInfo: React.FC<HospitalInfoProps> = ({ getSource }) => {
    const dataProvider = useDataProvider();
    const record = useRecordContext();
    const validateName = createCenterNameValidator(3, 500, dataProvider, record, 'Назва');
    const validateCity = createLengthValidator(3, 50, 'Назва міста');
    const validateAddress = createLengthValidator(3, 300, 'Адреса');

    return (
        <>
            <Typography variant="h6" component="h6" mb={3} fontWeight="600">
                Лікарня
            </Typography>
            <Grid container columnSpacing={4} rowSpacing={1}>
                <Grid item xs={12}>
                    <ShsTextInput
                        source={getSource(CenterFormFields.NAME)}
                        label="Назва лікарні"
                        required
                        validate={validateName}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ShsTextInput
                        source={getSource(CenterFormFields.CITY)}
                        label="Місто"
                        required
                        validate={validateCity}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ShsTextInput
                        source={getSource(CenterFormFields.HOSPITAL_ADDRESS)}
                        label="Адреса"
                        required
                        validate={validateAddress}
                    />
                </Grid>
            </Grid>
        </>
    );
};
